export const calculateStep = (clubSignup) => {
  let step = 'customer';
  if (clubSignup.data) {
    if (
      step === 'customer' &&
      (clubSignup.data.email || clubSignup.data.customerId) &&
      (clubSignup.data.shipTo ||
        clubSignup.data.orderDeliveryMethod === 'Pickup')
    ) {
      step = 'billing';
    }
    if (step === 'billing' && clubSignup.data.billTo) {
      if (clubSignup.data.customer) {
        step = 'payment';
      } else {
        step = 'account';
      }
    }
    if (
      step === 'payment' &&
      clubSignup.data.billTo &&
      clubSignup.data.creditCard
    ) {
      step = 'complete';
    }
  }
  return step;
};

export const stepArray = [
  'customer',
  'billing',
  'account',
  'payment',
  'complete'
];

export const editStep = (clubSignup, step) => {
  const currentStep = calculateStep(clubSignup);
  const currentStepPosition = stepArray.indexOf(currentStep);
  const newStepPosition = stepArray.indexOf(step);
  if (currentStepPosition < newStepPosition) {
    return currentStep;
  }
  return step;
};
